import { Outlet } from 'react-router-dom'

import AllConversationsSidebar from 'src/features/chats/components/all-conversations-sidebar'

const ChatsLayout = () => {
  return (
    <div className="flex size-full min-h-0 flex-1 flex-row overflow-hidden">
      <AllConversationsSidebar />
      <div className="h-full w-px bg-lightBorder" />
      <div className="flex min-h-0 flex-1 flex-col overflow-hidden">
        <Outlet />
      </div>
    </div>
  )
}

export default ChatsLayout
